import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { getCatalogBibEntities } from '../EntitiesSelector';

const getCurrentBibId = state => state.getIn(['catalogBibs', 'catalogBib', 'id'], Immutable.Map());

export const getCatalogBib = createSelector(
  [getCatalogBibEntities, getCurrentBibId],
  (catalogBibs, id) => catalogBibs.get(id)
);

export const getContributorNames = createSelector(
  [getCatalogBib],
  catalogBib =>
    catalogBib
      .get('fields', Immutable.List())
      .find(fieldSet => fieldSet.get('category') === 'CONTRIBUTORS', null, Immutable.Map())
      .get('items', Immutable.List())
      .find(fieldSet => fieldSet.get('fieldName') === 'CONTRIBUTOR_NAME', null, null)
);

export const getContainedWork = createSelector(
  [getCatalogBib],
  catalogBib =>
    catalogBib
      .get('fields', Immutable.List())
      .find(fieldSet => fieldSet.get('category') === 'CONTAINS', null, Immutable.Map())
      .get('items', Immutable.List())
      .find(fieldSet => fieldSet.get('fieldName') === 'CONTAINS_WORK', null, Immutable.Map())
      .get('fieldValues', Immutable.List())
);

export const getSubjectsAndGenres = createSelector(
  [getCatalogBib],
  catalogBib => {
    const fieldItems = catalogBib
      .get('fields', Immutable.List())
      .find(fieldSet => fieldSet.get('category') === 'SUBJECTGENRE', null, Immutable.Map())
      .get('items', Immutable.List());

    return fieldItems.flatMap(fieldItem => fieldItem.get('fieldValues', Immutable.List()));
  }
);

export default {
  getCatalogBib,
  getContributorNames,
  getContainedWork,
  getSubjectsAndGenres
};
